// src/utils/piSdk.js

export async function loginWithPi() {
  if (!window.Pi) {
    console.warn("⚠️ Pi SDK not available");
    return null;
  }

  try {
    const scopes = ["username", "payments"];
    const authResult = await window.Pi.authenticate(scopes);
    console.log("✅ Login success:", authResult);
    return authResult;
  } catch (error) {
    console.error("❌ Pi login failed:", error);
    return null;
  }
}
